export default class YouTubeVideo {
  constructor() {
    this.cookieName = 'youtubeaccepted';
    this.selector = '[data-youtube-id]';
    this.youtubePlayerIsReady = false;

    return this;
  }

  init() {
    this.elements = document.querySelectorAll(this.selector);

    // Bail if no elements found
    if (this.elements.length < 1) {
      return this;
    }

    // Request the cookie
    const cookie = this.getCookie(this.cookieName);

    if (cookie) {
      this.initYoutubeScript();
      this.replaceAllPlaceholders();

      return this;
    }

    this.addEventListeners();

    return this;
  }

  initYoutubeScript() {
    const youtubeScriptId = 'youtube-api';
    const youtubeScript = document.getElementById(youtubeScriptId);

    if (youtubeScript === null) {
      const tag = document.createElement('script');

      tag.src = 'https://www.youtube.com/iframe_api';
      tag.id = youtubeScriptId;
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    return this;
  }

  // eslint-disable-next-line class-methods-use-this
  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();

    return null;
  }

  setCookie(name) {
    document.cookie = `${name}=true; expires=Fri, 31 Dec 2030 23:59:59 GMT`;

    return this;
  }

  replaceAllPlaceholders() {
    if (typeof YT === 'undefined' || !this.youtubePlayerIsReady) {
      window.onYouTubeIframeAPIReady = () => {
        [...this.elements].forEach((element) => {
          this.prepareYoutubeVideo(element);
        });
        this.youtubePlayerIsReady = true;
      };
    } else if (this.youtubePlayerIsReady) {
      [...this.elements].forEach((element) => {
        this.prepareYoutubeVideo(element);
      });
    }

    return this;
  }

  replacePlaceholder(element, autoplay = false) {
    if (typeof YT === 'undefined' || !this.youtubePlayerIsReady) {
      window.onYouTubeIframeAPIReady = () => {
        this.prepareYoutubeVideo(element, autoplay);
        this.youtubePlayerIsReady = true;
      };
    } else if (this.youtubePlayerIsReady) {
      this.prepareYoutubeVideo(element, autoplay);
    }

    return this;
  }

  prepareYoutubeVideo(element, autoplay = false) {
    const placeholder = element.querySelector('.placeholder');
    const newElement = document.createElement('div');
    const currentUrl = `${window.location.protocol}//${window.location.hostname}`;
    const $element = element;
    const youTubeID = $element.dataset.youtubeId;
    let autoplayParamenter = 0;

    if (autoplay) {
      autoplayParamenter = 1;
    }

    newElement.classList.add('iframe');
    placeholder.remove();
    element.appendChild(newElement);

    window.youtubePlayers[youTubeID] = new window.YT.Player(newElement, {
      width: '100%',
      height: '100%',
      videoId: youTubeID,
      playerVars: {
        autoplay: autoplayParamenter,
        enablejsapi: 1,
        modestbranding: 0,
        rel: 0,
        showinfo: 0,
        html5: 1,
        origin: currentUrl,
      },
      events: {
        onStateChange: this.onPlayerStateChange,
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  onPlayerStateChange(event) {
    const played = event.target.getIframe().getAttribute('data-played');
    if (!played && event.data === window.YT.PlayerState.PLAYING) {
      // track video play with matomo (only once per video per page!)
      window._mtm = window._mtm || []; // eslint-disable-line no-underscore-dangle
      window._mtm.push({ // eslint-disable-line no-underscore-dangle
        event: 'playVideo',
        'dlv-videoTitle': event.target.getVideoData().title,
        'dlv-videoUrl': event.target.getVideoUrl(),
      });
      event.target.getIframe().setAttribute('data-played', 'true');
    }
  }

  addEventListeners() {
    [...this.elements].forEach((element) => {
      const $element = element;
      const $button = $element.querySelector('.button');

      $button.addEventListener('click', () => {
        this.initYoutubeScript();
        this.replaceAllPlaceholders();
        this.replacePlaceholder($element, true);
      });
    });
  }
}
